import React, { useEffect, useState } from "react";
import { Gift, CheckCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useI18n } from "@/i18n/I18nContext";
import api from "@/lib/api";
import { ADMIN } from "@/constants/testIds";

export default function GiftsTab() {
  const { t } = useI18n();
  const [items, setItems] = useState([]);

  const load = () => api.get("/admin/gifts").then(({ data }) => setItems(data));
  useEffect(() => { load(); }, []);

  const markSent = async (id) => {
    await api.post(`/admin/gifts/${id}/mark-sent`);
    load();
  };

  if (items.length === 0) {
    return <div className="rounded-2xl border border-dashed border-border p-12 text-center text-muted-foreground">{t("admin.noResults")}</div>;
  }

  return (
    <div className="space-y-4">
      {items.map((o) => (
        <div key={o.order_id} className="flex flex-col gap-3 rounded-2xl border border-border bg-card p-5 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <p className="flex items-center gap-2 font-medium"><Gift className="h-4 w-4 text-primary" />{o.form.gift_name}</p>
            <p className="text-xs text-muted-foreground">{o.form.gift_email} · {t("wizard.giftDateLabel")}: {o.form.gift_send_date || "-"}</p>
            <p className="mt-1 text-xs italic text-muted-foreground">"{o.form.gift_message}"</p>
          </div>
          {o.gift_sent ? (
            <span className="flex items-center gap-1 text-xs text-success"><CheckCircle className="h-4 w-4" />{t("admin.markGiftSent")}</span>
          ) : (
            <Button size="sm" className="rounded-full" data-testid={ADMIN.markGiftSentBtn(o.order_id)} onClick={() => markSent(o.order_id)}>
              {t("admin.markGiftSent")}
            </Button>
          )}
        </div>
      ))}
    </div>
  );
}
